
import { 
  authorityActivityMap, 
  entityActivityMap, 
  buyerLegalTypeMap, 
  contractNatureMap,
  procedureTypeMap,
  noticeTypeMap,
  mainActivityMap,
  documentAccessMap,
  getTedCodeDescription
} from './tedCodeMappings';

// This utility provides additional descriptions for fields not covered by standard TED code mappings

/**
 * Gets a human-readable description for a field based on its key and value
 */
export const getFieldDescription = (key: string, value: string): string | undefined => {
  if (!value) return undefined;
  
  if (key === 'funding') {
    const fundingMap: Record<string, string> = {
      'eu-funds': 'EU Funded',
      'not-eu-funds': 'Not EU Funded'
    };
    return fundingMap[value];
  }
  
  if (key === 'corporate-body') {
    const corporateBodyMap: Record<string, string> = {
      'true': 'Public Law Body',
      'false': 'Not a Public Law Body'
    };
    return corporateBodyMap[value];
  }
  
  // Handle boolean values represented as strings
  if (['true', 'false'].includes(value) && !key.includes('description')) {
    return value === 'true' ? 'Yes' : 'No';
  }
  
  // For known codes that might appear in non-standard fields
  if (authorityActivityMap[value]) return authorityActivityMap[value];
  if (entityActivityMap[value]) return entityActivityMap[value];
  if (buyerLegalTypeMap[value]) return buyerLegalTypeMap[value];
  if (contractNatureMap[value]) return contractNatureMap[value];
  if (procedureTypeMap[value]) return procedureTypeMap[value];
  if (noticeTypeMap[value]) return noticeTypeMap[value];

  return undefined;
};

/**
 * Gets a human-readable description for a procedure type code
 */
export const getProcedureTypeDescription = (procedureType: string): string => {
  return procedureTypeMap[procedureType] || procedureType;
};

/**
 * Gets a human-readable description for a contract nature code
 */
export const getContractNatureDescription = (contractNature: string): string => {
  return contractNatureMap[contractNature] || contractNature;
};

/**
 * Gets a human-readable description for a document restriction code
 */
export const getDocumentRestrictionDescription = (restrictionCode: string): string => {
  return documentAccessMap[restrictionCode] || restrictionCode;
};

/**
 * Gets a human-readable description for a submission language code
 */
export const getSubmissionLanguageDescription = (langCode: string): string => {
  const languageMap: Record<string, string> = {
    'eng': 'English',
    'bul': 'Bulgarian',
    'ces': 'Czech',
    'dan': 'Danish',
    'deu': 'German',
    'ell': 'Greek',
    'est': 'Estonian',
    'fin': 'Finnish',
    'fra': 'French',
    'hrv': 'Croatian',
    'hun': 'Hungarian',
    'gle': 'Irish',
    'ita': 'Italian',
    'lav': 'Latvian',
    'lit': 'Lithuanian',
    'mlt': 'Maltese',
    'nld': 'Dutch',
    'pol': 'Polish',
    'por': 'Portuguese',
    'ron': 'Romanian',
    'slk': 'Slovak',
    'slv': 'Slovenian',
    'spa': 'Spanish',
    'swe': 'Swedish',
    'mul': 'Multiple Languages'
  };
  
  return languageMap[langCode] || langCode;
};

